import { Sized } from '@optimus-web/common';
import { ActivableRendererProps } from '@optimus-web/helpers';
import { ButtonProps } from '../Button';

export enum DialogPosition {
    Center = 'center',
    Corner = 'corner',
}

export interface DialogFooterProps {
    secondary?: React.ReactElement | null;
    primary: React.ReactElement;
    responsive?: boolean;
}

export interface DialogBaseProps extends ActivableRendererProps, Sized {
    active?: boolean;
    modal?: boolean;
    position?: `${DialogPosition}`;
    contentWithoutPadding?: boolean;
    /**
     * @deprecated use footer.primary
     */
    actions?: Array<ButtonProps & { key?: string }>;
    /**
     * @deprecated use footer.secondary
     */
    footerDetail?: React.ReactNode;
    portalContainerId?: string;
    children?: React.ReactNode;
    footer?: DialogFooterProps;
    onClose?: (e: React.MouseEvent) => void;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    anchorElement?: HTMLElement | null;
    defaultFocusElement?: HTMLElement | null | (() => HTMLElement | null);
    /**
     * @deprecated
     */
    noMaxWidth?: boolean;
    mobileFullscreen?: boolean;
    loading?: boolean;
    fullWidthTitle?: boolean;
    lockScroll?: boolean;
    className?: string;
    contentRef?: React.RefObject<HTMLDivElement>;
}

export type DialogProps = DialogBaseProps;
